import React from "react";

import { getPreviewFramePrintFontSize } from "@/utils/qrEditorHelper";

import { QRFRameToPrintProps } from "../types";

import { uriText } from "./uri";

import "../styles.scss";

export const LikeFrameToDownload = (props: QRFRameToPrintProps): React.SVGProps<SVGSVGElement> => {
  const {
    text,
    textColor,
    frameColor,
    frameBackgroundColor,
    height = 1200,
    qrSvg,
    width = 900,
  } = props;

  const fontSize = getPreviewFramePrintFontSize(text?.length);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none">
      <style>
        {`
              @font-face {
                font-family: 'Nunito Sans';
                src: url(${uriText});
                font-weight: bold
              }
            `}
      </style>
      <g id="surface1">
        <path
          fillRule="nonzero"
          fill="white"
          fillOpacity="1"
          strokeWidth="1"
          stroke="#BFBFBF"
          d="M 7.999875 0.5 L 88.000125 0.5 C 92.142 0.5 95.500125 3.857839 95.500125 8 L 95.500125 120 C 95.500125 124.142161 92.142 127.5 88.000125 127.5 L 7.999875 127.5 C 3.858 127.5 0.499875 124.142161 0.499875 120 L 0.499875 8 C 0.499875 3.857839 3.858 0.5 7.999875 0.5 Z M 7.999875 0.5 "
          transform="matrix(10.416667,0,0,10.414062,0,0)"
        />

        <path
          stroke="none"
          fillRule="evenodd"
          fill={frameColor}
          d="M 605.226562 365.042969 L 605.007812 365.042969 C 609.652344 368.011719 612.734375 373.171875 612.734375 379.050781 C 612.734375 387.273438 606.714844 394.089844 598.800781 395.457031 C 598.652344 395.613281 598.523438 395.78125 598.386719 395.945312 C 599.867188 398.425781 600.726562 401.304688 600.726562 404.390625 C 600.726562 413.601562 593.183594 421.066406 583.878906 421.066406 L 488.164062 421.066406 C 482.582031 421.066406 476.796875 418.511719 471.203125 414.269531 L 471.203125 322.105469 C 480.257812 316.542969 489.171875 311.71875 495.332031 302.355469 C 511.5625 277.679688 517.914062 269.101562 539.355469 238.332031 C 544.902344 230.371094 545.066406 213.226562 551.363281 211.65625 C 552.558594 211.355469 553.679688 211.207031 554.722656 211.207031 C 561.832031 211.207031 565.371094 218.203125 564.707031 232.996094 C 563.945312 249.953125 555.589844 272.566406 552.699219 279.679688 C 549.808594 286.792969 546.316406 294.675781 548.695312 298.351562 C 550.144531 300.59375 552.253906 301.65625 555.300781 302.355469 L 602.214844 302.355469 C 610.972656 302.355469 618.070312 309.519531 618.070312 318.359375 C 618.070312 324.394531 614.757812 329.628906 609.871094 332.355469 C 616.914062 334.351562 622.074219 340.757812 622.074219 348.371094 C 622.074219 357.578125 614.53125 365.042969 605.226562 365.042969 Z M 457.972656 425.066406 C 457.972656 429.484375 454.390625 433.070312 449.96875 433.070312 L 385.929688 433.070312 C 381.507812 433.070312 377.925781 429.484375 377.925781 425.066406 L 377.925781 310.355469 C 377.925781 305.9375 381.507812 302.355469 385.929688 302.355469 L 449.96875 302.355469 C 454.390625 302.355469 457.972656 305.9375 457.972656 310.355469 Z M 635.417969 348.371094 C 635.417969 341.550781 633.058594 335.113281 629.023438 329.964844 C 630.574219 326.355469 631.414062 322.417969 631.414062 318.359375 C 631.414062 302.179688 618.316406 289.015625 602.214844 289.015625 L 563.308594 289.015625 C 563.726562 287.964844 564.140625 286.949219 564.484375 286.105469 L 565.058594 284.699219 C 567.066406 279.765625 577.113281 254.113281 578.035156 233.59375 C 578.652344 219.832031 576.207031 210.566406 570.335938 204.425781 C 566.289062 200.195312 560.746094 197.867188 554.722656 197.867188 C 552.597656 197.867188 550.378906 198.152344 548.128906 198.714844 C 536.949219 201.507812 533.847656 213 531.582031 221.390625 C 530.742188 224.492188 529.476562 229.171875 528.410156 230.707031 C 523.152344 238.253906 518.800781 244.464844 514.988281 249.902344 C 503.089844 266.890625 496.535156 276.246094 484.183594 295.023438 C 481.011719 299.847656 476.539062 303.117188 470.984375 306.597656 C 469.203125 296.617188 460.457031 289.015625 449.96875 289.015625 L 385.929688 289.015625 C 374.160156 289.015625 364.582031 298.589844 364.582031 310.355469 L 364.582031 425.066406 C 364.582031 436.832031 374.160156 446.40625 385.929688 446.40625 L 449.96875 446.40625 C 460.109375 446.40625 468.621094 439.300781 470.785156 429.808594 C 476.582031 432.863281 482.402344 434.402344 488.164062 434.402344 L 583.878906 434.402344 C 600.527344 434.402344 614.070312 420.941406 614.070312 404.390625 C 614.070312 403.941406 614.058594 403.492188 614.039062 403.039062 C 621.421875 397.53125 626.078125 388.777344 626.078125 379.050781 C 626.078125 376.300781 625.703125 373.609375 624.992188 371.039062 C 631.375 365.53125 635.417969 357.414062 635.417969 348.371094 Z M 635.417969 348.371094 "
        />
        <path
          stroke="none"
          fillRule="evenodd"
          fill={frameColor}
          d="M 430.015625 394.699219 C 424.671875 394.699219 420.34375 399.03125 420.34375 404.371094 C 420.34375 409.710938 424.671875 414.042969 430.015625 414.042969 C 435.355469 414.042969 439.6875 409.710938 439.6875 404.371094 C 439.6875 399.03125 435.355469 394.699219 430.015625 394.699219 Z M 430.015625 394.699219 "
        />

        <path
          stroke="none"
          fillRule="nonzero"
          fill={frameBackgroundColor}
          d="M 260.417969 479.046875 L 739.582031 479.046875 C 751.089844 479.046875 760.417969 488.371094 760.417969 499.875 L 760.417969 978.921875 C 760.417969 990.425781 751.089844 999.75 739.582031 999.75 L 260.417969 999.75 C 248.910156 999.75 239.582031 990.425781 239.582031 978.921875 L 239.582031 499.875 C 239.582031 488.371094 248.910156 479.046875 260.417969 479.046875 Z M 260.417969 479.046875 "
        />
        <g
          stroke="null"
          transform="matrix(6.2212 0 0 6.2212 0 -55)"
          id="svg_485">
          <g
            dangerouslySetInnerHTML={{ __html: qrSvg }}
            stroke="null"
            id="svg_486"></g>
        </g>
        <text
          x="500"
          y="1100.3999700784689"
          dominantBaseline="middle"
          textAnchor="middle"
          fill={textColor}
          fontFamily="Nunito Sans"
          style={{ fontSize }}>
          {text}
        </text>
      </g>
    </svg>
  );
};
